import { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import EditUser from '../molecules/user/EditUser';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import DeleteUserAlert from '../molecules/alerts/DeleteUserAlert'
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { handleSnackBar } from '../../store/global/actions';
import { setFocusElement, toggleRightDrawer, reRenderInfoBuilder, setReRender } from '../../store/global/actions'
import DeleteIcon from '@material-ui/icons/Delete';

export default function User({ element }) {
    
    const dispatch = useDispatch();
    const [action, setAction] = useState(0);

    const detailsBC = [
        { label: 'Enterprise Application', url: null },
        { label: element.name, url: null }
    ];



    const onCompletion = (type, action) => {

        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    if (process.env.REACT_APP_AUTO_CLOSE == 'true') {
                        dispatch(toggleRightDrawer());
                    }
                    dispatch(setReRender());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(setFocusElement({}));
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    break;

            }
            dispatch(reRenderInfoBuilder());
            setAction({})
        }
    }

    return (
        <>
            <AppBar position="static">
                <Tabs value={0} aria-label="simple tabs example">
                    <Tab label="Enterprise Application" />
                </Tabs>
            </AppBar>


            <TabPanel value={0} index={0} >

                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>

                    <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete Enterprise Application" arrow>
                            <IconButton onClick={e => setAction({ action: 'delete_user' })}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>

                <Divider style={marginBottomForBreadCrumb} />
                <EditUser element={element} onCompletion={onCompletion} onClose={() => setAction({})} />
                {action.action == 'delete_user' &&
                    <DeleteUserAlert onCompletion={onCompletion} id={element.id} onClose={() => setAction({})} />
                }
            </TabPanel>


        </>
    )
}
